import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import styles from './styles.module.scss'
import { arrowLeft } from '../../../assets/svg/dashboard/main'
import { CIUP_STRUCTURE } from '../../../utils/const'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCiupData } from '../../../actions/dashboard'
import Loader from 'react-loader'
import { Check, Input } from '../../../assets/NewDashboard'



const MODES = [
  { value: 'vo', label: 'Высшее образование' },
  { value: 'spo', label: 'Среднее профессиональное образование' },
  // { value: 'do', label: 'Дополнительное профессиональное образование' },
]

const Details = () => {

  const dispatch = useDispatch()
  const history = useHistory()
  const { mode, criterion } = useParams()

  const {loading, ciup} = useSelector(state => state.dashboard)

  const criteriaGroups = CIUP_STRUCTURE[mode] || []
  const activeGroup = criteriaGroups.find(g => g.value === criterion)
  const criterias = activeGroup ? activeGroup.criterias : []
  const data = ciup[criterion]
  const activeMode = MODES.find(m => m.value === mode)

  useEffect(() => {
    // старые ссылки на удалённые разделы (напр. international_activity) — на первый доступный
    if (criteriaGroups.length && !activeGroup) {
      history.replace(`/dashboard_new/ciup/${mode}/${criteriaGroups[0].value}`)
      return
    }
    dispatch(getCiupData(mode, criterion))
  }, [mode, criterion])

  const goTo = (link) => () => history.push(link)

  const handleModeChange = (newMode) => {
    const firstCriterion = CIUP_STRUCTURE[newMode]?.[0]?.value
    if (firstCriterion) {
      history.push(`/dashboard_new/ciup/${newMode}/${firstCriterion}`)
    }
  }

  return (
    <div className={styles.detailsWrapper}>
      <div className={styles.detailsHeader} onClick={goTo('/dashboard_new/ciup')}>
        <div className={styles.backBtn}>{arrowLeft}</div>
        <div className={styles.headerTitles}>
          <h2>Комплексные показатели состояния деятельности вуза</h2>
          {(activeMode || activeGroup) && (
            <h3 className={styles.detailsSubHeader}>
              {activeMode?.label}
              {activeMode && activeGroup ? ' — ' : ''}
              {activeGroup?.name}
            </h3>
          )}
        </div>
      </div>
      <section className={styles.detailsContent}>
          <div className={styles.cardsArea}>
          <Loader loaded={!loading}>
            {criterias.map((item) => {
              const nullProcent = item.units === '%' && data?.[item.value] === null
              const value = nullProcent ? 100 : (data?.[item.value] || 0)
              const hasChildren = item.children && item.children.length > 0
              const checkMode = value < item.min ? 'notComplete' : value >= item.normal ? 'complete' : 'middle'
              return (
                <div className={`${styles.criteriaCard} ${hasChildren ? styles.criteriaCardFull : ''}`} key={item.value}>
                  <div className={styles.cardTop}>
                    <div className={styles.cardLeft}>
                      <p className={styles.criteriaName}>{item.name}</p>
                      <div className={styles.criteriaTags}>
                        {(item.tags || []).map((tag, i) => (
                          <span key={i} className={styles.tag} title={tag}>{tag}</span>
                        ))}
                      </div>
                    </div>
                    <div className={styles.cardRight}>
                      <div className={`${styles.criteriaValue} ${item.units === '%' ? styles.criteriaValueInline : ''}`}>
                        <span className={styles.valueNumber}>{value}</span>
                        <span className={styles.valueUnit}>{item.units}</span>
                      </div>
                      <Check className={styles.customCheck} mode={checkMode}/>
                    </div>
                  </div>
                  {hasChildren && (
                    <div className={styles.childrenList}>
                      {item.children.map((child) => {
                        const value = data?.[child.value] || 0
                        const checkMode = value < child.min ? 'notComplete' : value >= child.normal ? 'complete' : 'middle'
                        return (
                          <div className={styles.childRow} key={child.value}>
                            <p className={styles.childName}>{child.name}</p>
                            <div className={styles.childRight}>
                              <div className={`${styles.childValue} ${child.units === '%' ? styles.childValueInline : ''}`}>
                                <span className={styles.childNumber}>{value}</span>
                                <span className={styles.childUnit}>{child.units}</span>
                              </div>
                              <Check className={styles.customCheck} mode={checkMode}/>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )}
                </div>
              )
            })}
        </Loader>
          </div>
        <div className={styles.sideMenu}>
          <div className={styles.modeSelector}>
            {MODES.map((m) => (
              <label key={m.value} className={`${styles.modeOption} ${mode === m.value ? styles.modeOptionActive : ''}`}>
                <span className={styles.radioCircle} />
                <input
                  type="radio"
                  name="mode"
                  checked={mode === m.value}
                  onChange={() => handleModeChange(m.value)}
                />
                <span>{m.label}</span>
              </label>
            ))}
          </div>
          <div className={styles.criteriaMenu}>
            {criteriaGroups.map((group) => (
              <button
                key={group.value}
                className={`${styles.criteriaBtn} ${group.value === criterion ? styles.criteriaBtnActive : ''}`}
                onClick={goTo(`/dashboard_new/ciup/${mode}/${group.value}`)}
              >
                {group.name}
              </button>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Details